import G from './Getters';
import jimp from "jimp/es";

import imageMap from './imageMap';


function getImageIdsUsedByFigurePanelId(state,figurePanelId){


  let figurePanel = state.data.figurePanels[figurePanelId];

  let byCellId = {};

  let { grid } = figurePanel;
  for(let ii = 0; ii < grid.length; ii++){
    for(let jj = 0; jj < grid[0].length; jj++ ){
      let cellId = grid[ii][jj];
     
      let cellLocation = [ii,jj];
      let cell = figurePanel.cellGroups[ cellId ];

      if( !cell ){
        debugger;
      }

      let { value } = cell;
      

      if( value.valueType === "crop" ){

        let cellImageIds;
        
        if( value.expandable ){

          cellImageIds = Object.values(value.imageIdsByChannel).filter(x => x);

          /*let nodes = G.getMicroscopyExpansionNodes(state,{ figurePanelId,cellLocation })
          cellImageIds = Object.values(nodes).filter(node => {
            return node?.value?.channelGroup;
          }).map(node => {
            let { channelGroup } = node.value;
            return G.getImageSetImageIdBychannelGroup(state,{imageSetId,channelGroup});
          })
          */
        }else{

          let { annotationId } = value;
          let { imageId, imageSetId } = G.getCropFromAnnotation(state,{annotationId});
          cellImageIds = [ imageId ]
          
        }

        byCellId[ cellId ] = cellImageIds;
        
      }

      

    }
  }


  return byCellId;


  /*
  
  let isImageType = val => ['crop','image'].includes(val.value.valueType);


  let imageTypeCrops = Object.values(figurePanel.cellGroups).filter(isImageType)
  */


}


export default function getImageUrlMap(state,args={}){


  debugger;




  let figurePanelId = args.figurePanelId;
  if( !figurePanelId ){
      figurePanelId = state.selectedFigurePanelId;
      if( !figurePanelId ){
        throw Error("You must pass figurePanelId.");
      }
  }
   
  let imageIdsByCellId = getImageIdsUsedByFigurePanelId(state,figurePanelId); 
  let allImageIds = Object.values(imageIdsByCellId).flat();


  
    
  let cellGroupMapEntries = allImageIds.map(imageId => {

      let url = G.getImageRecordUrl(state,{imageId});
      let mappedUrl = imageMap[url] || url;

      
      return jimp.read(mappedUrl).then( image => {
        return image.getBase64Async("image/png").then( res => 
          [imageId, res]
        )

      }).catch(err => {
        
        console.log("Jimp had a problem reading the image.");
        console.error(err)
        return [imageId, undefined]
      });
    })

  console.log(cellGroupMapEntries);


  return Promise.all(cellGroupMapEntries).then(map => {
    console.log("Jimp map:");
    console.log(map);
    return Object.fromEntries(map);
  });

}


